import React from 'react'

import styled from 'styled-components'

import { BrandColors } from 'src/utilities/Colors'

import { Body3, TitleH4 } from '../blocks/Typography'

const MediaObjectWrapper = styled.div<{ alignItems: string }>`
  display: flex;
  align-items: ${props => props.alignItems};
`

const MediaObjectImage = styled.div<{
  backgroundColor: string
  size: string
  imageMarginRight: string
}>`
  margin-right: ${props => props.imageMarginRight};
  background-color: ${props => props.backgroundColor};
  width: ${props => props.size};
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
`

const MediaObjectBody = styled.div`
  flex: 1;
  > * {
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

interface IMediaObjectProps {
  alignItems?: string
  content: string | React.ReactNode
  image: React.ReactNode
  imageBgColor?: string
  imageMarginRight?: string
  size?: string
  title: string | React.ReactNode
  titleAs?: string
}

const MediaObject = ({
  alignItems = 'flex-start',
  content,
  image,
  imageBgColor = BrandColors.pigeon200,
  imageMarginRight = '1.5rem',
  size = '3.5rem',
  title,
  titleAs = 'h4'
}: IMediaObjectProps) => {
  return (
    <MediaObjectWrapper alignItems={alignItems} className='mediaObjectWrapper'>
      <MediaObjectImage
        backgroundColor={imageBgColor ? imageBgColor : 'transparent'}
        size={size}
        imageMarginRight={imageMarginRight}
      >
        {image}
      </MediaObjectImage>
      <MediaObjectBody>
        {title && typeof title === 'string' ? (
          <TitleH4 as={titleAs}>{title}</TitleH4>
        ) : (
          title
        )}

        {content && typeof content === 'string' ? (
          <Body3>{content}</Body3>
        ) : (
          content
        )}
      </MediaObjectBody>
    </MediaObjectWrapper>
  )
}

export default MediaObject
